import { render } from "./Stock_Transfers.vue?vue&type=template&id=0ddae0fd&scoped=true"
import script from "./Stock_Transfers.vue?vue&type=script&lang=js"
export * from "./Stock_Transfers.vue?vue&type=script&lang=js"

import "./Stock_Transfers.vue?vue&type=style&index=0&id=0ddae0fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ddae0fd"]])

export default __exports__